import { useState } from "react";
import { EventsListLogic } from "./EventsListLogic";

export function EventList({ showPast = true }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleOpen = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  const renderSection = (title, events, prefix) => (
    <div className="mb-4">
      <h3 className="mb-3">{title}</h3>
      <div className="accordion" id={`${prefix}-accordion`}>
        {events.length === 0 ? (
          <p className="text-muted">No events</p>
        ) : (
          events.map((event, i) => {
            const localIndex = `${prefix}-${i}`;
            return (
              <div className="accordion-item" key={event._id || i}>
                <h2 className="accordion-header" id={`heading-${localIndex}`}>
                  <button
                    className={`accordion-button ${openIndex === localIndex ? "" : "collapsed"}`}
                    type="button"
                    onClick={() => toggleOpen(localIndex)}
                    aria-expanded={openIndex === localIndex}
                    aria-controls={`collapse-${localIndex}`}
                  >
                    <div className="w-100 d-flex justify-content-between align-items-center">
                      <span>
                        <span className="fw-bold">
                          {new Date(event.date + "T00:00").toLocaleDateString(undefined, {
                            weekday: "long",
                            year: "numeric",
                            month: "long",
                            day: "numeric"
                          })}
                        </span>{" "}
                        {event.name}
                      </span>
                    </div>
                  </button>
                </h2>
                <div
                  id={`collapse-${localIndex}`}
                  className={`accordion-collapse collapse ${openIndex === localIndex ? "show" : ""}`}
                  aria-labelledby={`heading-${localIndex}`}
                >
                  <div className="accordion-body">
                    <ul className="list-unstyled mb-0">
                      {event.place && <li><strong>Place:</strong> {event.place}</li>}

                      {Array.isArray(event.time) && event.time.length > 0 && (
                        <li>
                          <strong>Time:</strong>
                          <ul className="mb-0">
                            {event.time.map((t, j) => (
                              <li key={j}>
                                <strong>{t.time}</strong>
                                {t.description && ` — ${t.description}`}
                                {t.public === false && <span className="text-muted"> (Private)</span>}
                              </li>
                            ))}
                          </ul>
                        </li>
                      )}

                      {event.co_chairs && <li><strong>Co-Chairs:</strong> {event.co_chairs}</li>}
                      {event.hostesses && <li><strong>Hostesses:</strong> {event.hostesses}</li>}
                      <li><strong>Open to Public:</strong> {event.public ? "Yes" : "No"}</li>
                    </ul>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );

  return (
    <EventsListLogic
      onlyPublic={false}
      render={({ upcoming, past }) => (
        <>
          {renderSection("Upcoming Events", upcoming, "upcoming")}
          {showPast && renderSection("Past Events", past, "past")}
        </>
      )}
    />
  );
}
